import { StringUtility, TimeUtility } from 'utility-ts-type';
import { Conversation } from '../../../src/builders/conversation_builder';
import { IConversationCardModel } from '../../../src/conversations_interface';

interface IConversationCardFlags {
  hasFlaggedThreads: boolean;
  hasMultipleThreads: boolean;
  hasUnreads: boolean;
}

export class ConversationCardController {
  private conversation: Conversation;
  private model: IConversationCardModel;
  private flags: IConversationCardFlags;

  constructor(private $state: ng.ui.IStateService) {}

  $onInit(): void {
    this.model = {
      email_message: this.htmlToPlainText(this.conversation.email_message),
      conversationDate: TimeUtility.getDateMonthDay(this.conversation.sent_timestamp),
      initials: StringUtility.getAcronym(...this.conversation.friendly_sender_name.split(' '))
    };

    this.flags = {
      hasFlaggedThreads: this.conversation.flagged > 0,
      hasMultipleThreads: this.conversation.total > 1,
      hasUnreads: this.conversation.unread > 0
    };
  }

  goToConversationThreads(): void {
    this.$state.go('my.conversations.threads', {
      id: this.conversation.id
    });
  }

  private htmlToPlainText(htmlText: string): string {
    const tempNode = document.createElement('DIV');
    tempNode.innerHTML = htmlText;
    return tempNode.textContent || tempNode.innerText || '';
  }
}

export class ConversationCardComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-conversations/src/components/conversation_card/conversation_card.html';
  public controller: any = ConversationCardController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    conversation: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/components/conversation_card/conversation_card_controller.ts